<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <el-button size="small" icon="el-icon-paperclip" round>选择文件</el-button>
      <ellipsis :row="1" :content="placeholder + sizeTip" hoverTip slot="tip" class="el-upload__tip" />
    </div>
    <div v-else>
      <el-upload
        :file-list="_value"
        action="#"
        :limit="maxSize"
        with-credentials
        :multiple="maxSize > 0"
        :show-file-list="false"
        :data="uploadParams"
        :before-upload="beforeUpload"
      >
        <el-button size="small" icon="el-icon-paperclip" round>选择文件</el-button>
      </el-upload>
      <div class="upload-list" v-for="(file,index) in _value " :key='index'>
        <div style="font-size: 12px;display: flex;align-items: center">
          <div style="margin-right: 10px;color: #67C23A;">{{file.name}}</div>
          <div v-if="file.loading == true" style="font-size: 15px" class="el-icon-loading"></div>
          <div v-else style="color: #67C23A;font-size: 15px" class="el-icon-circle-check"></div>
        </div>
        <div v-if="file.loading == false">
          <el-button @click="downloadFileByUrl(file)" type="text" icon="el-icon-download" size="medium"></el-button>
          <el-button @click="deleteUploadItem(index)" type="text" style="color: red" icon="el-icon-delete" size="medium"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins';
import { uploadFiles } from "../../../../api/utils/uploadFile";

import { downloadALink } from "/src/utils/fileUtils";
export default {
  mixins: [componentMinxins],
  name: 'ImageUpload',
  components: {},
  props: {
    placeholder: {
      type: String,
      default: '请选择附件',
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    maxSize: {
      type: Number,
      default: 5,
    },
    maxNumber: {
      type: Number,
      default: 10,
    },
    fileTypes: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    sizeTip() {
      if (this.fileTypes.length > 0) {
        return ` | 只允许上传[${String(this.fileTypes).replaceAll(',', '、')}]格式的文件，且单个附件不超过${this.maxSize}MB`;
      }
      return this.maxSize > 0 ? ` | 单个附件不超过${this.maxSize}MB` : '';
    },
  },
  data() {
    return {
      disabled: false,
      uploadParams: {},
    };
  },
  methods: {
    deleteUploadItem(index){
      this._value.splice(index, 1);
    },
    downloadFileByUrl(val){
      if (val.url == null){
        this.$message.warning("未检测到线上文件地址！");
        return false;
      }
      downloadALink(val.url,val.name);
    },
    beforeUpload(file) {
      console.log(file)
      if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`文件过大，请选择小于 ${this.maxSize}MB`);
        return false;
      }
      const ext = file.name.slice(file.name.lastIndexOf('.') + 1);
      let uid = Date.now() + Math.floor(Math.random() * 1000);
      let item = {name: uid+'.'+ext, url: null, uid: uid,loading:true};
      this._value.push(item);
      const data = new FormData()
      data.append('multipartFile',file);
      uploadFiles(data).then(res => {
        if (res.data) {
          const item = this._value.find(item => item.uid === uid);
          if (item) {
            item.loading = false;
            item.url = res.data;
          }
          this.$emit('input', this._value);
        }
      });
      return true;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file);
    },
  },
};
</script>

<style lang="less" scoped>
.upload-list{
  display:flex;justify-content: space-between;align-items: center
}

</style>
